import { BaseModule } from "./base.module";
import { svg, html, css, LitElement } from 'lit';
export class NexusComponent extends LitElement {

    context = 'design-system';
    styleSheetPrefix = '';
    debugMode = false;

    baseModule = new BaseModule();
    _root = document;

    constructor() {
        super();
        this.guessContext();
        this.generateStyleSheetLocationPrefixBasedOnContext();
    }

    /**
     * 
     * This is used to generate style sheet location prefix for web component modularized style loading for shadow root based component
     * 
     * @returns string
     */
    guessContext() {
        this.context = 'nexus-wordpress';
        if (
            typeof window !== 'undefined' &&
            window.location.hostname == 'localhost'
        ) {
            this.context = 'nexus-design-system';
        }
    }

    /**
     * 
     * This is used to generate style sheet location prefix for web component modularized style loading for shadow root based component
     * styleSheetPrefix can be used in stylesheet links from components, a structure to make them work in prototype environment as well as wordpress context
     */
    generateStyleSheetLocationPrefixBasedOnContext() {
        // if in localhost, we are in prototype environment
        if (this.context == 'nexus-design-system') {
            this.styleSheetPrefix = './../../';
        }
        if (this.context == 'nexus-wordpress') {
            this.styleSheetPrefix = '/wp-content/themes/jb-nexus-child/assets/dist/';
        }
    }

    /**
     * 
     * @param {string} eventName 
     * @param {Element} element 
     * @param {object} data
     */
    triggerEventOnElement(eventName, element, data = {}) {
        // console.log(eventName, 'on element', element,'with data', data);
        return this.baseModule.triggerEventOnElement(eventName, element, data);
    }

    initialize() {

    }

    setRoot(root) {
        this._root = root;
    }
    getRoot() {
        this._root;
    }
}